import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useProStatus() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const d = await api("/users/me/pro");
      setData(d);
    } catch (e) {
      console.error("Failed to load Pro status:", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { data, loading, refresh, isPro: !!data?.is_pro };
}
